import React from "react";
import FilterBox from "../../../Utils/FilterBox/FilterBox"

function Filter(props) {

    const { setPageParams } = props

    let filterTypes = {
        external_id: {
            type: "string",
            disabled: false,
            validation: false,
            description: "ID do Lote"
        },
        status: {
            type: "string",
            disabled: false,
            validation: false,
            description: "Status"
        },
        created_at: {
            type: "date",
            disabled: false,
            validation: false,
            description: "Data de Criação"
        }
    }

    return (
        <FilterBox
            setPageParams={setPageParams}
            filterTypes={filterTypes}
            local_storage_object_preffix={props.local_storage_object_preffix}
        />
    )

}

export default Filter